
import { useMediaQuery } from "react-responsive";

import Card1 from './modules/card1'
import Card2 from './modules/card2'
import Card3 from './modules/card3'
import Card4 from './modules/card4'

const Solutions = () => {
 const isDesktop = useMediaQuery({ minWidth: 769 });

  return (
    <div style={{minHeight: '400px'}}>
      <Card1 />
      <Card2 />
      <Card3 />
      <Card4 />

    </div>
  )
}

export default Solutions